import React from "react";

interface ILoader {
  size?: "small" | "big";
}

const Loader = ({ size }: ILoader) => {
  return (
    <div className={`preloader-wrapper ${size} active`}>
      <div className="spinner-layer">
        <div className="circle-clipper left">
          <div className="circle"></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
